import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Card, Flex, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';
import { useParams } from 'react-router';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

type HistoricVolume = {
  date: string;
  supply: string | number;
  withdraw: string | number;
  borrow: string | number;
  repay: string | number;
};

export default function HistoricTabs() {
  const { walletAddress } = useParams();
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('borrow_repay');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'borrow_repay', value: 'Borrow/Repay' },
      { key: 'supply_withdraw', value: 'Supply/Withdraw' }
    ],
    []
  );

  const [data, error] = useApi<HistoricVolume[]>({
    url: `/wallets/${walletAddress}/historic-volume/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>

      <HistoricGraphs
        data={data as SimpleChartData[]}
        type={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    </Card>
  );
}
